const routes = [
    {
      path: '/company/landing',
      name: 'CompanyLanding',
      component: () => import('../../views/company/landing/LandingPage.vue')
    },
]

export default routes;